import React from 'react';
import styled from 'styled-components';

const StyledH3 = styled.h3`
  :before {
    background: ${({ landingPrimaryColor }) => landingPrimaryColor} !important;
  }
`;

const About = ({ aboutUs, landingPrimaryColor }) => {
  return (
    aboutUs && (
      <section
        id="about-link"
        class="why-choose"
        style={{
          fontFamily: 'Poppins, sans-serif',
          padding: '0px 0px !important',
        }}
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-12">
              <div class="choose-left">
                <StyledH3 landingPrimaryColor={landingPrimaryColor}>
                  Who We Are
                </StyledH3>
                {aboutUs}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  );
};

export default About;
